module.exports = "/images/lamoral.jpg?a52234155b747db2683871f2265f7e6d";